import React from "react";
import { connect } from 'react-redux';

const PledgeTile = props => {
    const { report, currentYear } = props; 
    // Get Current year data to show current year score 
    let currentYearReport = report && report.length > 0 && report.filter(item => item.year === currentYear)[0];
    const pledge = currentYearReport && currentYearReport.pledge ? currentYearReport.pledge : '';
    try {
        return <div className="card myPledge-tile">
            <div className="card-header">
                <div className="row">
                    <div className="col-12">
                        <div className="card-heading d-flex">
                            <span className="svg-pledge"></span>
                            <div className="myPledge-heading">MY PLEDGE</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-body mt-2">
                <div className="row">
                    <div className="col-12">
                        <p>{pledge}</p>
                    </div>
                </div>
            </div>
        </div>;
    } catch (ex) {
        console.error(ex);
    }
}

function mapStateToProps(state) {
    return {
        report: state.thrive.report
    };
}

export default connect(mapStateToProps, null)(PledgeTile);